<template>
  <div class="content">
    <!-- 页面标题 -->
    <div v-wechat-title="'《新仙剑奇侠传之挥剑问情》一周年庆典活动'"></div>
      <!-- 移动端 -->
      <div id="main-mobile" v-if="match === 'mobile'" v-show="isShow" style="min-width: 320px; max-width: 540px;" ref="mobile">
        <!-- 头部 -->
        <div class="header">
          <div class="icon"></div>
          <div class="user">{{ role_name ? role_name : (user_account ? user_account : '一周年庆 为谁而挥剑') }}</div>
          <div class="login-btn" v-show="!user_account" @click="changeLoginPopup(true)"></div>
          <div class="logout-btn" v-show="user_account" @click="osCancel()"></div>
          <div class="official-btn" @click="goLink('https://hjwq.qingcijoy.com/', '挥剑问情_周年服新服预约活动_跳转至官网')"></div>
        </div>

        <!-- 侧栏 -->
        <div class="aside">
          <div :class="['item', 'one', asideIndex <= 1 ? 'active' : '']" @click="handleScroll(1)"></div>
          <div :class="['item', 'two', asideIndex === 2 ? 'active' : '']" @click="handleScroll(2)"></div>
          <div :class="['item', 'three', asideIndex === 3 ? 'active' : '']" @click="handleScroll(3)"></div>
          <div :class="['item', 'four', asideIndex === 4 ? 'active' : '']" @click="handleScroll(4)"></div>
          <div :class="['item', 'five', asideIndex === 5 ? 'active' : '']" @click="handleScroll(5)"></div>
          <!-- <div class="prev-btn" @click="asideIndex > 1 ? (asideIndex--, handleScroll(asideIndex)) : ''"></div> -->
          <!-- <div class="next-btn" @click="asideIndex < 5 ? (asideIndex++, handleScroll(asideIndex)) : ''"></div> -->
        </div>

        <!-- 首页 -->
        <div class="content_01">
          <div class="bottom"></div>
          <div class="slogan"></div>
          <div class="next-icon"></div>
        </div>

        <!-- 福利一 -->
        <div class="content_02">
          <div class="title"></div>
          <div class="main">
            <div class="item one" v-show="person >= 5000"></div>
            <div class="item two" v-show="person >= 10000"></div>
            <div class="item three" v-show="person >= 30000"></div>
          </div>
          <div class="text">
            <div class="left"></div>
            <div class="right">{{person}}</div>
          </div>
          <div :class="['btn', is_open_start ? 'over' : 'prebook', user_account && isPrebook ? 'already' : '']" @click="is_open_start ? download() : toPrebook()"></div>
        </div>

        <!-- 福利二 -->
        <div class="content_03">
          <div class="title"></div>
          <div class="rule" @click="showPopup('ruleTwo', true)"></div>
          <div class="person">
            <!-- 添加ani类名呈现动画 -->
            <div :class="['item', has_card.includes(peopleId[index]) ? '' : 'mask', card_id === (peopleId[index]) ? 'ani' : '']" v-for="(item,index) in 15" :key="index"></div>
          </div>
          <div :class="['wish', has_card.length === 15 ? 'already' : '']" @click="has_card.length === 15 ? '' : wish()"></div>
          <div class="num">剩余祈愿次数：{{collect_dice}} 次</div>
          <div class="task">
            <div :class="['btn', item.is_get ? 'isGet' : '', item._get ? 'finish' : '']" v-for="(item,index) in task_info" :key="index" @click="onTask(item.id, item._get, item.is_get, item.link, item.title)"></div>
          </div>
          <div class="reward">
            <div :class="['item', item._get ? 'get' : '', item.is_get ? 'is_get' : '', 'item' + collect_number, 'item' + choice_id, collect_number || choice_id ? 'select' : '']" v-for="(item,index) in collect_reward" :key="index" @click="(index === 2  && !item.is_get && has_card.length === 15) ? showPopup('receivePeople', true) : '', isGetReward(item._get)"></div>
            <div class="receive-btn" @click="showPopup('confirmReceive', true)"></div>
          </div>
        </div>

        <!-- 福利三 -->
        <div class="content_04">
          <div class="title"></div>
          <div class="lottery">
            <div class="btn" @click="lottery()"></div>
            <div class="num">剩余抽奖次数：{{lottery_dice}} 次</div>
          </div>
          <div class="detail" @click="showPopup('getReward', true)"></div>
          <div class="rule" @click="showPopup('ruleThree', true)"></div>
          <div class="invite">
            <div :class="['item', 'item' + item.status]" v-for="(item,index) in team_info" :key="index" @click="toInvite(item.nickname)">
              <img :src="item.avatar" v-show="item.nickname">
            </div>
            <div class="num">{{ invite_num }}</div>
            <div class="bind" @click="is_bind ? '' : threeBind()">{{ is_bind ? ('已绑定 ' + bind_role_name + bind_server_name) : '绑定周年服角色>>' }}</div>
            <div class="code">{{ invite_code }}</div>
            <div id="clipboard-btn" @click="copyLink('#clipboard-btn')" data-event="复制邀请码" :data-clipboard-text="'《新仙剑之挥剑问情》周年庆典来袭，仙剑党不容错过的最佳入坑时机！精品茅台、Switch等海量福利等你拿，戳 https://h5.qingcigame.com/hjwq/prebook/enter 预约周年服！我的邀请码：' + invite_code"></div>
            <div class="write" @click="showPopup('code', true)"></div>
            <div class="receive" @click="showPopup('getNum', true)"></div>
          </div>
        </div>

        <!-- 福利四 -->
        <div class="content_05">
          <div class="title"></div>
          <div class="rule" @click="showPopup('ruleFour', true)"></div>
          <div class="record" @click="showPopup('record', true)"></div>
          <div class="main">
            <div class="item" v-for="(item,index) in orderList" :key="index" @click="preOrder(item.id, item.is_get, item._get, item.price, item.package_id)">
              <div :class="['btn', item._get ? 'purchased' : '', item.is_get ? 'received' : '',is_buy ? 'buy' : 'buyOver', is_reward_start ? 'receive' : 'receiveOver', user_account ? 'login' : 'logout' ]"></div>
            </div>
          </div>
        </div>

        <!-- 周年庆特色 -->
        <div class="content_06">
          <div class="title"></div>
          <div class="swiper1">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../../../../assets/images/active/hjwq/prebook/swiper_01.png" v-show="swiperIndex === 6 || swiperIndex === 0 || swiperIndex === 1">
              </div>
              <div class="swiper-slide">
                <img src="../../../../assets/images/active/hjwq/prebook/swiper_02.png" v-show="0 <= swiperIndex <= 2">
              </div>
              <div class="swiper-slide">
                <img src="../../../../assets/images/active/hjwq/prebook/swiper_03.png" v-show="1 <= swiperIndex <= 3">
              </div>
              <div class="swiper-slide">
                <img src="../../../../assets/images/active/hjwq/prebook/swiper_04.png" v-show="2 <= swiperIndex <= 4">
              </div>
              <div class="swiper-slide">
                <img src="../../../../assets/images/active/hjwq/prebook/swiper_05.png" v-show="3 <= swiperIndex <= 5">
              </div>
              <div class="swiper-slide">
                <img src="../../../../assets/images/active/hjwq/prebook/swiper_06.png" v-show="4 <= swiperIndex <= 6">
              </div>
              <div class="swiper-slide">
                <img src="../../../../assets/images/active/hjwq/prebook/swiper_07.png" v-show="swiperIndex === 5 || swiperIndex === 6 || swiperIndex === 0">
              </div>
            </div>
          </div>
          <div class="swiper-prev-btn"></div>
          <div class="swiper-next-btn"></div>
          <div class="swiper-pagination"></div>
        </div>

        <!-- 弹窗 -->
        <div class="popupWrap" style="min-width: 320px; max-width: 540px;">
          <!-- 点亮侠客 -->
          <div v-if="false" :class="'popup lightPeopleFalse ' + lightPeopleFalse" @click.self="showPopup('lightPeopleFalse', false)">
            <div class="main">
              <div class="confirm-btn" @click.self="showPopup('lightPeopleFalse', false)"></div>
            </div>
          </div>

          <!-- 抽奖次数 -->
          <div :class="'popup getNum ' + getNum" @click.self="showPopup('getNum', false)">
            <div class="main">
              <div class="item-wrap">
                <!-- 我的邀请人 -->
                <div class="invited" v-show="my_inviter.length">
                  <div class="item" v-for="(item,index) in my_inviter" :key="index">
                    <div class="num">{{item.remark}}</div>
                    <div :class="['receive-btn', 'btn' + item.is_get]" @click="item.is_get === 0 ? receiveNum() : ''"></div>
                  </div>
                </div>
                <!-- 我邀请的人 -->
                <div class="invite" v-show="person_invited.length">
                  <div class="item" v-for="(item,index) in person_invited" :key="index">
                    <div class="num">{{item.remark}}</div>
                    <div :class="['receive-btn', 'btn' + item.is_get]" @click="item.is_get === 0 ? receiveNum() : ''"></div>
                  </div>
                </div>
                <!-- 新玩家/回归玩家 -->
                <div class="new" v-show="new_player.length">
                  <div class="item" v-for="(item,index) in new_player" :key="index">
                    <div class="num">{{item.remark}}</div>
                    <div :class="['receive-btn', 'btn' + item.is_get]" @click="item.is_get === 0 ? receiveNum() : ''"></div>
                  </div>
                </div>
                <!-- 周年服角色达到35级 -->
                <div class="level" v-show="level_reach.length">
                  <div class="item" v-for="(item,index) in level_reach" :key="index">
                    <div class="num">{{item.remark}}</div>
                    <div :class="['receive-btn', 'two', 'btn' + item.is_get]" @click="item.is_get === 0 ? receiveNum() : ''"></div>
                  </div>
                </div>
              </div>
              <!-- 一键领取 -->
              <div class="receive-all-btn" @click="receiveNum()"></div>
            </div>
          </div>

          <!-- 分享 -->
          <div :class="'popup share ' + share" @click.self="showPopup('share', false)">
            <div class="main">
              <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接" :data-clipboard-text="'《新仙剑之挥剑问情》周年庆典来袭，仙剑党不容错过的最佳入坑时机！精品茅台、Switch等海量福利等你拿，戳 https://h5.qingcigame.com/hjwq/prebook/enter 预约周年服！我的邀请码：' + invite_code"></div>
            </div>
          </div>

          <!-- 分享遮罩 -->
          <div :class="'popup shareShadow ' + shareShadow" @click.self="showPopup('shareShadow', false)">
            <div class="main" @click="showPopup('shareShadow', false)"></div>
          </div>

          <!-- 侠影祈愿规则 -->
          <div :class="'popup ruleTwo ' + ruleTwo" @click.self="showPopup('ruleTwo', false)">
            <div class="main">
              <div class="text">
                <img src="../../../../assets/images/active/hjwq/prebook/popup/ruleTwo_text.png" alt="">
              </div>
            </div>
          </div>

          <!-- 庆典邀约规则 -->
          <div :class="'popup ruleThree ' + ruleThree" @click.self="showPopup('ruleThree', false)">
            <div class="main">
              <div class="text">
                <img src="../../../../assets/images/active/hjwq/prebook/popup/ruleThree_text.png" alt="">
              </div>
            </div>
          </div>

          <!-- 周年预购规则 -->
          <div :class="'popup ruleFour ' + ruleFour" @click.self="showPopup('ruleFour', false)">
            <div class="main"></div>
          </div>

          <!-- 获奖明细 -->
          <div :class="'popup getReward ' + getReward" @click.self="showPopup('getReward', false)">
            <div class="main">
              <div class="item-wrap">
                <div class="item" v-for="(item,index) in lottery_list" :key="index">
                  <div class="text">{{item.remark}}</div>
                  <div :class="['btn', item.is_send === 1 ? 'already' : '']" @click="item.is_send === 1 ? '' : receiveLottery(item.is_good, item.id)"></div>
                </div>
              </div>
              <div class="role">{{ server_name }} {{ role_name }}</div>
              <div class="bind" @click="changeBind()">{{ role_name ? '切换>>' : '绑定角色' }}</div>
            </div>
          </div>

          <!-- 区服选择 -->
          <div :class="'popup server ' + server" @click.self="showPopup('server', false)">
            <div class="main">
              <div class="group">
                <span @click="serverShow = !serverShow">{{popup_server_name ? popup_server_name : '请选择区组'}}</span>
                <div class="choice" v-show="serverShow">
                  <div class="item current" @click="select([])">请选择区组</div>
                  <div class="item" v-for="(item,index) in serverInfo" :key="index" @click="select(item)">{{ item.server_name }}</div>
                </div>
              </div>
              <div class="role">{{popup_role_name ? popup_role_name : '请选择角色'}}</div>
              <div class="btn">
                <div class="cancel" @click="osCancel()">注销</div>
                <div class="confirm" @click="bindConfirm()">确认</div>
              </div>
            </div>
          </div>

          <!-- 领取实物奖励 -->
          <div :class="'popup goods ' + goods" @click.self="showPopup('goods', false)">
            <div class="main">
              <input type="text" v-model="write_name" placeholder="请填写你的姓名">
              <input type="text" v-model="write_phone" placeholder="请填写你的联系电话">
              <input type="text" v-model="write_address" placeholder="请填写你的快递地址">
              <div class="confirm-btn" @click="receiveGoods()"></div>
            </div>
          </div>

          <!-- 绑定用户 -->
          <div :class="'popup bind ' + bind" @click.self="showPopup('bind', false)">
            <div class="main">
              <div class="info">{{popup_server_name}}&emsp;{{ popup_role_name }}</div>
              <div class="confirm" @click="confirmBind()"></div>
              <div class="cancel" @click="showPopup('bind', false)"></div>
            </div>
          </div>

          <!-- 邀请码 -->
          <div :class="'popup code ' + code" @click.self="showPopup('code', false)">
            <div class="main">
              <input type="text" v-model="write_code">
              <div class="confirm-btn" @click="onHelp()"></div>
            </div>
          </div>

          <!-- 抽奖提示 -->
          <div :class="'popup notice ' + notice" @click.self="showPopup('notice', false)">
            <div class="main">
              <div class="name">{{rewardName}}</div>
              <div :class="['pic', 'pic' + prize_id]"></div>
              <div class="confirm-btn" @click="showPopup('notice', false)"></div>
            </div>
          </div>

          <!-- 确认领取 -->
          <div :class="'popup confirmReceive ' + confirmReceive" @click.self="showPopup('confirmReceive', false)">
            <div class="main">
              <div class="name">{{ this.role_name }}</div>
              <div class="server">{{ this.server_name }}</div>
              <div class="confirm-btn" @click="onReward()"></div>
            </div>
          </div>

          <!-- 领取成功 -->
          <div :class="'popup receiveSuccess ' + receiveSuccess" @click.self="showPopup('receiveSuccess', false)">
            <div class="main">
              <div class="confirm-btn" @click="showPopup('receiveSuccess', false)"></div>
            </div>
          </div>

          <!-- 领取侠客 -->
          <div :class="'popup receivePeople ' + receivePeople" @click.self="showPopup('receivePeople', false)">
            <div class="main">
              <div class="item-wrap">
                <div :class="['item', 'item' + item, people === item ? 'light' : '']" v-for="(item,index) in has_card" :key="index" @click="people = item"></div>
              </div>
              <div class="confirm-btn" @click="collect_number = people, showPopup('receivePeople', false)"></div>
            </div>
          </div>

          <!-- 点亮侠客 -->
          <div :class="'popup lightPeople ' + lightPeople" @click.self="showPopup('lightPeople', false)">
            <div class="main">
              <div class="name">{{ card_info }}</div>
              <div class="confirm-btn" @click="showPopup('lightPeople', false)"></div>
            </div>
          </div>

          <!-- 预约成功 -->
          <div :class="'popup prebook ' + prebook" @click.self="showPopup('prebook', false)">
            <div class="main">
              <div class="confirm-btn" @click="showPopup('prebook', false)"></div>
            </div>
          </div>

          <!-- 支付 -->
          <div :class="'popup payment ' + payment" @click.self="showPopup('payment', false)">
            <div class="main">
              <div :class="['item', item.icon, item.icon === paymentData.icon ? 'current' : '']" v-for="(item,index) in paymentList" :key="index" @click="paymentData = item"></div>
              <div class="confirm-btn" @click="goToPay()"></div>
            </div>
          </div>

          <!-- 支付提示 -->
          <div :class="'popup paymentTips ' + paymentTips" @click.self="showPopup('paymentTips', false)">
            <div class="main">
              <div class="title">提示</div>
              <div class="text">请确认是否完成支付</div>
              <div class="item confirm" @click="orderQuery(true)">已完成支付</div>
              <div class="item cancel" @click="orderQuery(false)">未完成支付</div>
            </div>
          </div>

          <!-- 支付成功 -->
          <div :class="'popup paymentSuccess ' + paymentSuccess" @click.self="showPopup('paymentSuccess', false)">
            <div class="main">
              <div class="title">提示</div>
              <div class="text">支付成功</div>
              <div class="confirm-btn" @click="showPopup('paymentSuccess', false)">确定</div>
            </div>
          </div>

          <!-- 购买记录 -->
          <div :class="'popup record ' + record" @click.self="showPopup('record', false)">
            <div class="main">
              <div class="item" v-for="(item,index) in pay_list" :key="index">
                <div class="name">{{ item.remark }}</div>
                <div class="prize">{{ item.price }}元</div>
                <div class="time">{{ item.updated_at.substring(5) }}</div>
              </div>
            </div>
          </div>

          <!-- 备战群二维码 -->
          <div :class="'popup player ' + player" @click.self="showPopup('player', false)">
            <div class="main">
              <div class="confirm-btn" @click="showPopup('player', false)"></div>
            </div>
          </div>

          <!-- 备战群二维码 -->
          <div :class="'popup wxMask ' + wxMask" @click.self="showPopup('wxMask', false)">
            <div class="main" @click="wxMask = false"></div>
          </div>

          <!-- 加载页 -->
          <div :class="'popup loading ' + loading">
            <div class="main"></div>
          </div>

        </div>

        <!-- 防抖 -->
        <div class="prevent" style="min-width: 320px; max-width: 540px;" v-show="isPrevent"></div>

        <!-- 登录弹窗 -->
        <Login v-if='isShowLogin'
          :gameName="gameName"
          :loginTypes="loginTypes"
          :downloadUrl="downloadUrl"
          channelTips="角色UID可在游戏中—头像—ID查看"></Login>

        <!-- 支付宝调用标签 -->
        <div id="aliPayBtn"></div>

      </div>

      <!-- pc端 -->
      <div id="main-pc" v-if="match === 'pc'" style="min-width: 1200px; max-width: 1920px;">
        <div class="slogan"></div>
        <div class="code"></div>
      </div>

      <!-- 预加载 -->
      <div id="preloading" v-if="match === 'mobile'" v-show="!isShow" style="min-width: 320px; max-width: 540px;"></div>
  </div>
</template>

<script>
import { onInitAPI, onNumberAPI, onLogoutAPI, onTaskAPI, onTaskGetAPI, onCollectAPI, onRewardAPI, onHelpAPI, onShowAPI, onBindAPI, onGameServerAPI, onGameBindAPI, onBookRewardAPI, onBuyAPI, onBuyShowAPI, wechatInfoAPI, onGetAPI, onLotteryAPI, onAddressAPI } from '../api'
import { Toast, Indicator } from 'mint-ui'
import { getTimeStamp, buriedLogger, wechatBrowser } from '@/utils/utils'
import Clipboard from 'clipboard'
import { mapState, mapMutations, mapActions } from 'vuex'
import Login from '@/components/login'
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'prebook',
  components: {
    swiper,
    Login
  },
  data () {
    return {
      gameName: 'hjwq',
      loginTypes: ['sms', 'password'],
      downloadUrl: 'https://hjwq.qingcijoy.com/',
      downLoadLink: '',
      logger: null,
      match: null, // 设备
      isShow: true, // 预加载是否完成
      asideIndex: 0, // 侧栏索引
      peopleId: [8, 5, 10, 12, 2, 9, 4, 1, 6, 15, 3, 11, 13, 7, 14], // 侠客id顺序
      invite_num: 0, // 当前邀请人数
      isNew: false, // 是否为周年新服
      serverInfo: [], // 区组信息
      newServerInfo: [], // 周年新服区组信息
      newServerInfo2: [], // 达到35级的周年新服区组信息
      allServerInfo: [], // 全部区组信息
      serverShow: false, // 区服选择选项
      server_name: null,
      server_id: null,
      role_name: null,
      role_id: null,
      game_id: null,
      popup_server_name: null,
      popup_server_id: null,
      popup_role_name: null,
      popup_role_id: null,
      popup_game_id: null,
      rewardBind: null, // 绑定后领奖流程number
      rewardName: null, // 当前抽到的奖励名
      prize_id: null, // 前抽到的奖励id
      reward_id: null, // 当前领取的奖励id
      isPrebook: null, // 是否已经预约
      swiperIndex: 0, // 轮播图active索引

      lightPeopleFalse: false, // 请点亮侠客弹窗
      getNum: false, // 抽奖次数弹窗
      share: false, // 分享弹窗
      shareShadow: false, // 分享遮罩
      ruleTwo: false, // 侠影祈愿规则弹窗
      ruleThree: false, // 庆典邀约规则弹窗
      ruleFour: false, // 周年预购规则弹窗
      server: false, // 区服选择弹窗
      goods: false, // 领取实物奖励弹窗
      bind: false, // 绑定用户弹窗
      code: false, // 邀请码弹窗
      notice: false, // 抽奖提示弹窗
      getReward: false, // 获奖明细弹窗
      receiveSuccess: false, // 领取成功弹窗
      confirmReceive: false, // 确认领取弹窗
      receivePeople: false, // 领取侠客弹窗
      lightPeople: false, // 点亮侠客弹窗
      prebook: false, // 预约成功弹窗
      payment: false, // 支付弹窗
      paymentTips: false, // 支付提示弹窗
      paymentSuccess: false, // 支付成功弹窗
      record: false, // 购买记录弹窗
      player: false, // 备战群二维码弹窗
      loading: false, // 加载页
      isPrevent: false, // 防抖
      wxMask: false, // 微信遮罩

      write_name: '', // 用户填写的姓名
      write_phone: '', // 用户填写的手机号
      write_address: '', // 用户填写的地址
      write_code: '', // 用户填写的邀请码
      people: null, // 领取侠客弹窗-当前选中Id
      shareLink: '', // 分享链接
      user_account: null,
      user_id: null,
      person: null, // 预约人数
      collect_dice: 0, // 剩余祈愿次数
      collect_reward: ['', '', ''], // 点亮侠客任务信息
      collect_reward_number: 0, // 点亮侠客奖励待领取的数量
      choice_id: 0, // 已领取的自选侠客id
      collect_number: null, // 点亮任务-选择的侠客id
      has_card: [], // 已点亮侠客
      task_info: ['', '', '', '', ''], // 祈愿任务信息
      card_id: null, // 祈愿的侠客id
      card_info: null, // 祈愿的侠客
      invite_code: 'xxxxxxx', // 我的邀请码
      is_has_invite: false, // 是否已填写并绑定邀请码
      is_bind: null, // 是否已绑定周年服角色
      bind_role_name: null, // 绑定的周年服角色名
      bind_server_name: null, // 绑定的周年服区服名
      lottery_dice: 0, // 抽奖次数
      lottery_list: [], // 获奖明细
      my_inviter: [], // 我的邀请人
      person_invited: [], // 我邀请的人
      new_player: [], // 新玩家&回归玩家
      level_reach: [], // 周年服角色35级
      team_info: [], // 邀请队列信息
      is_open_start: false, // 游戏是否已开服
      is_collect_end: false, // 侠影祈愿活动是否结束
      is_invite_end: false, // 庆典邀约活动是否结束
      is_buy: false, // 预购礼包是否售卖
      is_reward_start: false, // 预购礼包是否开启领取
      orderList: ['', '', ''], // 订单信息
      pay_list: [], // 购买记录

      // 当前支付方式
      paymentList: [
        { icon: 'zfb', name: '支付宝支付', select: '1', pay_type: 'alipay', pay_method: 'wap' },
        { icon: 'wx', name: '微信支付', select: '0', pay_type: 'wechat', pay_method: 'mp' }
      ],
      // 单独支付宝支付方式
      paymentList1: [
        { icon: 'zfb', name: '支付宝支付', select: '1', pay_type: 'alipay', pay_method: 'wap' }
      ],
      // 单独微信支付方式
      paymentList2: [
        { icon: 'wx', name: '微信支付', select: '0', pay_type: 'wechat', pay_method: 'mp' }
      ],
      paymentData: null, // 当前支付类型
      open_id: '', // open_id微信支付用
      order_id: null, // 订单id
      order: '' // 支付订单
    }
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin'
    ])
  },
  created () {
    // 设备判断 & 自适应
    window.addEventListener('pageshow', this.resize)
    window.addEventListener('resize', this.resize)

    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()

    // 埋点
    const bl = buriedLogger('hjwq', '挥剑问情_周年服新服预约活动_访问页面')
    this.logger = bl
    setTimeout(() => {
      this.logger.sum('挥剑问情_周年服新服预约活动_访问页面')
    }, 200)

    // 微信app内，需要获取openid才能做微信支付
    if (wechatBrowser()) {
      wechatInfoAPI().then((response) => {
        if (Number(response.code) === 200) {
          this.open_id = response.data.open_id
          if (response.data.open_id == null) {
            window.location.href = '//api.qingcigame.com/wechat/get/open/?back=' + encodeURIComponent(window.location.href)
          }
        } else {
          bl.error({name: '微信授权信息错误', message: `详情: ${response.message}`})
          this.onToast(response.message)
        }
      })
    }
    this.device()

    this.isSetShare()
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        this.onInit()
      }
    },
    role_id: {
      handler (newValue, oldValue) {
        this.isNew = false
        for (let i = 0; i < this.newServerInfo.length; i++) {
          if (this.newServerInfo[i].role_id === newValue) this.isNew = true
          break
        }
      }
    }
  },
  methods: {
    // 设备判断 & 自适应
    resize () {
      this.match = navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i) ? 'mobile' : 'pc'
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        if (this.match === 'pc') {
          // pc端
          let fontSize
          if (window.innerWidth > 1920) {
            fontSize = '75px'
          } else if (window.innerWidth < 1200) {
            fontSize = 75 / 1920 * 1200 + 'px'
          } else {
            fontSize = 75 / 1920 * window.innerWidth + 'px'
          }
          document.getElementsByTagName('html')[0].style.fontSize = fontSize
        } else if (this.match === 'mobile') {
          // 移动端
          this.swiper1 ? this.swiper1.init() : this.swiperInit()
          this.$refs.mobile.addEventListener('scroll', this.onScroll)
        }
      }, 320)
    },
    // 环境判断
    device () {
      // 微信环境下微信支付，其他为支付宝支付
      this.paymentList = wechatBrowser() ? this.paymentList2 : this.paymentList1
      this.paymentData = this.paymentList[0]
    },
    // 初始化
    onInit () {
      onInitAPI({

      }).then(response => {
        if (Number(response.code) === 200) {
          this.user_account = response.data.user_info.user_account
          this.user_id = response.data.user_info.user_id
          this.collect_dice = response.data.activity.collect.collect_dice
          this.collect_reward = response.data.activity.collect.collect_reward.data
          this.collect_reward_number = response.data.activity.collect.collect_reward.number
          this.choice_id = response.data.activity.collect.collect_reward.choice_id
          this.has_card = response.data.activity.collect.has_card
          this.task_info = response.data.activity.collect.task_info
          this.is_collect_end = response.data.activity.collect.is_collect_end
          this.invite_code = response.data.activity.invite.code
          this.is_has_invite = response.data.activity.invite.is_has_invite
          this.lottery_dice = response.data.activity.invite.lottery_dice
          this.lottery_list = response.data.activity.invite.lottery_list
          this.my_inviter = response.data.activity.invite.lottery_record.my_inviter
          this.person_invited = response.data.activity.invite.lottery_record.person_invited
          this.new_player = response.data.activity.invite.lottery_record.new_player
          this.level_reach = response.data.activity.invite.lottery_record.level_reach
          this.team_info = response.data.activity.invite.team_info
          this.is_bind = response.data.activity.invite.is_bind
          this.bind_role_name = response.data.activity.invite.role_name
          this.bind_server_name = response.data.activity.invite.server_name
          this.is_invite_end = response.data.activity.invite.is_invite_end
          this.is_open_start = response.data.activity.is_open_start
          this.is_reward_start = response.data.activity.is_reward_start
          this.is_buy = response.data.activity.order.is_buy
          this.orderList = response.data.activity.order.list
          this.pay_list = response.data.activity.order.pay_list
          this.person = response.data.activity.number
          this.isPrebook = localStorage.getItem('isPrebook' + this.user_account)

          // 当前邀请人数
          let a = 0
          this.team_info.forEach(item => {
            if (item.nickname) a++
          })
          this.invite_num = a

          // 字符串转数组
          this.has_card = this.has_card.split('[')[1].split(']')[0].split(',')
          let arr = []
          this.has_card.forEach(item => {
            arr.push(Number(item))
          })
          this.has_card = arr

          // this.is_open_start = false; this.is_collect_end = false; this.is_invite_end = false; this.is_buy = true; this.is_reward_start = false // 5.30-6.7
          // this.is_open_start = true; this.is_collect_end = false; this.is_invite_end = false; this.is_buy = false; this.is_reward_start = true // 6.7-6.20
          // this.is_open_start = true; this.is_collect_end = true; this.is_invite_end = true; this.is_buy = false; this.is_reward_start = true // 6.21-6.30
          // this.is_open_start = true; this.is_collect_end = true; this.is_invite_end = true; this.is_buy = false; this.is_reward_start = false // 7.1
          return
        }
        if (Number(response.code) === 401) {
          this.onNumber()
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        // this.onToast('服务器出错啦')
      })
    },
    // 拉取预约人数
    onNumber () {
      onNumberAPI({

      }).then(response => {
        if (Number(response.code) === 200) {
          this.person = response.data.number
          this.is_open_start = response.data.is_open_start
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 查询所有角色
    searchAll () {
      if (!this.allServerInfo.length) {
        return new Promise((resolve, reject) => {
          onGameServerAPI({
            account: this.user_account,
            page_id: 8,
            app_id: 58
          }).then(response => {
            if (Number(response.code) === 200) {
              let a = response.data[58] ? response.data[58].android : [] // 光子服
              let b = response.data[69] ? response.data[69].android : [] // 正式服
              this.allServerInfo = a.concat(b)
              resolve()
              return
            }
            Number(response.code) !== 401 && Number(response.code) !== 405 && this.onToast(response.message)
            resolve()
          }).catch((err) => {
            reject(err)
          })
        })
      }
    },
    // 查询新服角色
    searchNew () {
      if (!this.newServerInfo.length) {
        return new Promise((resolve, reject) => {
          onShowAPI({
            filter: 0
          }).then(response => {
            if (Number(response.code) === 200) {
              this.newServerInfo = response.data[69] ? response.data[69].android : []
              resolve()
              return
            }
            Number(response.code) !== 401 && Number(response.code) !== 405 && this.onToast(response.message)
            resolve()
          }).catch((err) => {
            reject(err)
          })
        })
      }
    },
    // 查询达到35级的新服角色
    searchNew2 () {
      if (!this.newServerInfo2.length) {
        return new Promise((resolve, reject) => {
          onShowAPI({
            filter: 1
          }).then(response => {
            if (Number(response.code) === 200) {
              this.newServerInfo2 = response.data[69] ? response.data[69].android : []
              resolve()
              return
            }
            Number(response.code) !== 401 && Number(response.code) !== 405 && this.onToast(response.message)
            resolve()
          }).catch((err) => {
            reject(err)
          })
        })
      }
    },
    // 侧栏监听滚动
    onScroll (e) {
      if (this.timer2) clearTimeout(this.timer2)
      this.timer2 = setTimeout(() => {
        const scrollTop = e.target.scrollTop
        const header = document.getElementsByClassName('header')[0].clientHeight
        const two = document.getElementsByClassName('content_02')[0].offsetTop
        const three = document.getElementsByClassName('content_03')[0].offsetTop
        const four = document.getElementsByClassName('content_04')[0].offsetTop
        const five = document.getElementsByClassName('content_05')[0].offsetTop
        const six = document.getElementsByClassName('content_06')[0].offsetTop
        const buffer = Math.floor(window.innerHeight * 0.25)
        if (scrollTop >= six - header - buffer) {
          this.asideIndex = 5
        } else if (scrollTop >= five - header - buffer) {
          this.asideIndex = 4
        } else if (scrollTop >= four - header - buffer) {
          this.asideIndex = 3
        } else if (scrollTop >= three - header - buffer) {
          this.asideIndex = 2
        } else if (scrollTop >= two - header - buffer) {
          this.asideIndex = 1
        } else {
          this.asideIndex = 0
        }
      }, 50)
    },
    // 侧栏点击滚动
    handleScroll (index) {
      this.asideIndex = index
      const top = document.getElementsByClassName(`content_0${index + 1}`)[0].offsetTop - document.getElementsByClassName('header')[0].clientHeight
      document.getElementById('main-mobile').scrollTo({top, behavior: 'smooth'})
    },
    // 轮播图初始化
    swiperInit () {
      let that = this
      setTimeout(() => {
        this.swiper1 = new Swiper('.swiper1', {
          loop: true,
          autoplay: 5000,
          direction: 'vertical',
          autoplayDisableOnInteraction: false,
          slidesPerView: 'auto',
          centeredSlides: true,
          allowTouchMove: false,
          effect: 'coverflow',
          coverflow: {
            rotate: 0,
            stretch: 85,
            slideShadows: false
          },
          onSlideChangeStart: function () {
            that.swiperIndex = that.swiper1 ? that.swiper1.realIndex : 0
          },
          prevButton: '.swiper-prev-btn',
          nextButton: '.swiper-next-btn',
          pagination: '.swiper-pagination'
        })
      }, 200)
    },
    // 打开 || 关闭弹窗
    async showPopup (name, boolean) {
      switch (name) {
        case 'lightPeopleFalse':
          if (!boolean) {
            this.lightPeopleFalse = false
            return
          }
          if (this.is_collect_end) return this.onToast('活动已结束')
          this.lightPeopleFalse = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开提示解锁侠客弹窗')
          break
        case 'getNum':
          if (!boolean) {
            this.getNum = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          if (this.is_invite_end) return this.onToast('活动已结束')
          this.getNum = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开领取抽奖次数弹窗')
          break
        case 'share':
          if (!boolean) {
            this.share = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          if (this.is_invite_end) return this.onToast('活动已结束')
          this.share = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开分享弹窗')
          break
        case 'shareShadow':
          if (!boolean) {
            this.shareShadow = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          if (this.is_invite_end) return this.onToast('活动已结束')
          this.shareShadow = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开分享弹窗')
          break
        case 'ruleTwo':
          this.ruleTwo = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开侠影祈愿规则弹窗')
          break
        case 'ruleThree':
          this.ruleThree = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开庆典邀约规则弹窗')
          break
        case 'ruleFour':
          this.ruleFour = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开周年预购规则弹窗')
          break
        case 'server':
          if (!boolean) {
            this.server = false
            this.popup_server_name = null
            this.popup_server_id = null
            this.popup_role_name = null
            this.popup_role_id = null
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          this.server = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开区服选择弹窗')
          break
        case 'goods':
          this.goods = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开领取实物奖励弹窗')
          if (!boolean) {
            this.write_phone = ''
            this.write_address = ''
            this.write_code = ''
          }
          break
        case 'bind':
          if (!boolean) {
            this.bind = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          await this.searchNew()
          if (!this.newServerInfo.length) return this.onToast('您的账号还未创建新服角色')
          this.serverInfo = this.newServerInfo
          this.bind = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开绑定用户弹窗')
          break
        case 'code':
          if (!boolean) {
            this.code = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          if (this.is_invite_end) return this.onToast('活动已结束')
          if (this.is_has_invite) return this.onToast('已填写并绑定邀请码')
          this.code = boolean
          boolean ? this.logger.sum('挥剑问情_周年服新服预约活动_打开邀请码弹窗') : this.write_code = ''
          break
        case 'notice':
          this.notice = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开抽奖提示弹窗')
          break
        case 'getReward':
          if (!boolean) {
            this.getReward = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          this.getReward = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开获奖明细弹窗')
          break
        case 'receiveSuccess':
          this.showPopup('server', false)
          this.showPopup('conformReceive', false)
          this.receiveSuccess = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开领取成功弹窗')
          break
        case 'confirmReceive':
          if (!boolean) {
            this.confirmReceive = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          if (!this.is_open_start) {
            return this.onToast('领奖未开始')
          } else {
            if (!this.is_buy && !this.is_reward_start) return this.onToast('活动已结束')
          }
          if (!this.collect_reward_number) return this.onToast('暂无待领取的奖励')
          if (this.collect_reward[2]._get && !this.collect_number) return this.onToast('请选择想要的超尘侠客')
          await this.searchNew()
          if (!this.newServerInfo.length) return this.onToast('未查询到周年服角色')
          this.serverInfo = this.newServerInfo
          this.rewardBind = 1
          this.showPopup('server', true)
          break
        case 'receivePeople':
          this.receivePeople = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开领取侠客弹窗')
          break
        case 'lightPeople':
          this.lightPeople = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开点亮侠客弹窗')
          break
        case 'prebook':
          if (!boolean) {
            this.prebook = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          this.prebook = boolean
          if (boolean) {
            this.onNumber()
            this.logger.sum('挥剑问情_周年服新服预约活动_打开预约成功弹窗')
          }
          break
        case 'payment':
          this.payment = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开支付弹窗')
          break
        case 'paymentTips':
          this.paymentTips = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开支付提示弹窗')
          break
        case 'paymentSuccess':
          this.paymentSuccess = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开支付成功弹窗')
          break
        case 'record':
          if (!boolean) {
            this.record = false
            return
          }
          if (!this.user_account) {
            this.changeLoginPopup(true)
            this.onToast('请先登录')
            return
          }
          this.record = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开购买记录弹窗')
          break
        case 'player':
          this.player = boolean
          if (boolean) this.logger.sum('挥剑问情_周年服新服预约活动_打开备战群二维码弹窗')
          break
      }
    },
    // 福利一-下载游戏按钮
    download () {
      this.logger.sum('挥剑问情_周年服新服预约活动_点击下载游戏')
      if (navigator.userAgent.match(/(iPhone|iPod|ios)/i)) {
        this.downLoadLink = 'https://apps.apple.com/cn/app/%E6%96%B0%E4%BB%99%E5%89%91%E5%A5%87%E4%BE%A0%E4%BC%A0%E4%B9%8B%E6%8C%A5%E5%89%91%E9%97%AE%E6%83%85-%E5%91%A8%E5%B9%B4%E5%BA%86/id6447745041'
      } else {
        this.downLoadLink = 'http://apk2.79yougame.com/xianjian/qcts/0530/xianjian_qc30030530.apk'
      }
      if (wechatBrowser()) {
        this.wxMask = true
      } else {
        location.href = this.downLoadLink
      }
    },
    isGetReward (_get) {
      if (this.user_account && !_get) {
        // this.showPopup('lightPeopleFalse', true)
        this.onToast('该奖励还未解锁~ 请先点亮侠客哦')
      }
    },
    toPrebook () {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (this.user_account && !this.isPrebook) {
        this.isPrebook = true
        localStorage.setItem('isPrebook' + this.user_account, true)
        this.showPopup('prebook', true)
      }
    },
    // 祈愿侠客
    wish () {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (this.is_collect_end) return this.onToast('活动已结束')
      if (!this.collect_dice) return this.onToast('祈愿次数不足')
      if (this.timer3) clearTimeout(this.timer3)
      this.timer3 = setTimeout(() => { // 防抖
        this.isPrevent = true
        Indicator.open()
        onCollectAPI({

        }).then(response => {
          Indicator.close()
          if (Number(response.code) === 200) {
            this.card_info = response.data.card_info
            this.card_id = response.data.card_id
            if (this.has_card.includes(this.card_id)) {
              // 该角色已点亮
              this.showPopup('lightPeople', true)
              this.onInit()
              setTimeout(() => {
                this.isPrevent = false // 等待弹窗显示
              }, 600)
            } else {
              setTimeout(() => {
              // 点亮动画结束
                this.showPopup('lightPeople', true)
                this.onInit()
                setTimeout(() => {
                  this.isPrevent = false // 等待弹窗显示
                }, 600)
              }, 1000)
              return
            }
          }
          Number(response.code) !== 200 && this.onToast(response.message)
        }).catch(() => {
          this.onToast('服务器出错啦')
        })
      }, 300)
    },
    // 完成祈愿任务
    onTask (task_id, _get, is_get, link, title) {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (this.is_collect_end) return this.onToast('活动已结束')
      if (is_get) {
        // 已领取
        if (task_id === 1) {
          if (wechatBrowser()) {
            // 微信环境
            this.showPopup('shareShadow', true)
          } else if (navigator.userAgent.toLowerCase().indexOf('qq') !== -1) {
            if (navigator.userAgent.toLowerCase().indexOf('qqtheme') !== -1) {
              // qq内置浏览器
              this.showPopup('shareShadow', true)
            } else {
              // qq浏览器
              this.showPopup('share', true)
            }
          } else {
            // 其他环境
            this.showPopup('share', true)
          }
        }
        return
      }
      if (_get) {
        // 已完成
        this.finish(task_id)
      } else {
        // 未完成
        if (!link && task_id !== 1) return this.onToast('敬请期待')
        // 任务3
        if (task_id === 3) this.goLink(link, '挥剑问情_周年服新服预约活动_' + title)
        // 任务1，任务4，任务5
        if (task_id === 1 || task_id === 4 || task_id === 5) {
          onTaskAPI({
            task_id
          }).then(response => {
            if (Number(response.code) === 200) {
              if (task_id === 1) {
                if (wechatBrowser()) {
                  // 微信环境
                  this.showPopup('shareShadow', true)
                } else if (navigator.userAgent.toLowerCase().indexOf('qq') !== -1) {
                  if (navigator.userAgent.toLowerCase().indexOf('qqtheme') !== -1) {
                    // qq内置浏览器
                    this.showPopup('shareShadow', true)
                  } else {
                    // qq浏览器
                    this.showPopup('share', true)
                  }
                } else {
                  // 其他环境
                  this.showPopup('share', true)
                }
              }
              onInitAPI({

              }).then(response => {
                if (Number(response.code) === 200) {
                  this.task_info = response.data.activity.collect.task_info
                  if (task_id === 4) {
                    if (wechatBrowser()) {
                      // 打开备战群二维码弹窗
                      this.showPopup('player', true)
                    } else {
                      if (link) this.goLink(link, '挥剑问情_周年服新服预约活动_' + title)
                    }
                  } else {
                    if (link) this.goLink(link, '挥剑问情_周年服新服预约活动_' + title)
                  }
                  return
                }
                Number(response.code) !== 401 && this.onToast(response.message)
              }).catch(() => {
                // this.onToast('服务器出错啦')
              })
              return
            }
            Number(response.code) !== 200 && this.onToast(response.message)
          }).catch(() => {
            this.onToast('服务器出错啦')
          })
        }
      }
    },
    // 领取祈愿次数
    finish (task_id) {
      onTaskGetAPI({
        task_id
      }).then(response => {
        if (Number(response.code) === 200) {
          this.onInit()
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 领取收集奖励
    onReward () {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (!this.collect_reward_number) return this.onToast('暂无待领取的奖励')
      onRewardAPI({
        choice_id: this.collect_number ? this.collect_number : null
      }).then(response => {
        if (Number(response.code) === 200) {
          this.onInit()
          this.showPopup('receiveSuccess', true)
          this.showPopup('server', false)
          this.showPopup('confirmReceive', false)
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 福利三-邀请-绑定周年服角色
    async threeBind () {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (this.is_invite_end) return this.onToast('活动已结束')
      await this.searchNew2()
      if (!this.newServerInfo2.length) return this.onToast('未查询到等级达到35级的周年服角色')
      this.serverInfo = this.newServerInfo2
      this.rewardBind = 2
      this.showPopup('server', true)
    },
    // 区服选择-点击选项
    select (item) {
      this.popup_server_name = item.server_name ? item.server_name : null
      this.popup_server_id = item.server_id ? item.server_id : null
      this.popup_role_name = item.role_name ? item.role_name : null
      this.popup_role_id = item.role_id ? item.role_id : null
      this.popup_game_id = item.game_id ? item.game_id : null
      this.serverShow = false
    },
    // 区服选择-点击确认
    bindConfirm () {
      switch (this.rewardBind) {
        case 1:
          // 领取收集奖励
          this.server_id = this.popup_server_id
          this.server_name = this.popup_server_name
          this.role_id = this.popup_role_id
          this.role_name = this.popup_role_name
          this.game_id = this.popup_game_id
          onGameBindAPI({
            role_id: this.role_id,
            role_name: this.role_name,
            server_id: this.server_id,
            server_name: this.server_name,
            platform: 'android',
            game_id: '69',
            dist: 58
          }).then(response => {
            if (Number(response.code) === 200) {
              this.confirmReceive = true
              this.logger.sum('挥剑问情_周年服新服预约活动_打开确认领取弹窗')
              return
            }
            this.onToast(response.message)
          }).catch(() => {
            this.onToast('服务器出错啦')
          })
          break
        case 2:
          // 福利三-绑定周年服角色
          this.showPopup('bind', true)
          break
        case 3:
          // 福利三-获奖明细-点击领取(非实物)
          this.server_id = this.popup_server_id
          this.server_name = this.popup_server_name
          this.role_id = this.popup_role_id
          this.role_name = this.popup_role_name
          this.game_id = this.popup_game_id
          onGameBindAPI({
            role_id: this.role_id,
            role_name: this.role_name,
            server_id: this.server_id,
            server_name: this.server_name,
            platform: 'android',
            game_id: this.game_id,
            dist: 58
          }).then(response => {
            if (Number(response.code) === 200) {
              this.onBookReward(1)
              return
            }
            this.onToast(response.message)
          }).catch(() => {
            this.onToast('服务器出错啦')
          })
          break
        case 4:
          // 福利四-周年预购礼-点击领取奖励
          this.server_id = this.popup_server_id
          this.server_name = this.popup_server_name
          this.role_id = this.popup_role_id
          this.role_name = this.popup_role_name
          this.game_id = this.popup_game_id
          this.onBookReward(2)
          break
        case 5:
          // 福利三-获奖明细-换绑
          this.server_id = this.popup_server_id
          this.server_name = this.popup_server_name
          this.role_id = this.popup_role_id
          this.role_name = this.popup_role_name
          this.game_id = this.popup_game_id
          onGameBindAPI({
            role_id: this.role_id,
            role_name: this.role_name,
            server_id: this.server_id,
            server_name: this.server_name,
            platform: 'android',
            game_id: this.game_id,
            dist: 58
          }).then(response => {
            if (Number(response.code) === 200) {
              this.showPopup('server', false)
              this.onToast('绑定成功')
              return
            }
            this.onToast(response.message)
          }).catch(() => {
            this.onToast('服务器出错啦')
          })
          break
      }
    },
    // 确认绑定
    confirmBind () {
      this.server_id = this.popup_server_id
      this.server_name = this.popup_server_name
      this.role_id = this.popup_role_id
      this.role_name = this.popup_role_name
      this.game_id = this.popup_game_id
      onBindAPI({
        game_id: 69,
        role_id: this.role_id,
        role_name: this.role_name,
        server_id: this.server_id,
        platform: 'android'
      }).then(response => {
        if (Number(response.code) === 200) {
          this.onInit()
          this.showPopup('server', false)
          this.showPopup('bind', false)
          return
        }
        Number(response.code) !== 405 && this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 填写邀请码-确认绑定
    onHelp () {
      if (!this.write_code) this.onToast('邀请码不能为空')
      onHelpAPI({
        code: this.write_code
      }).then(response => {
        if (Number(response.code) === 200) {
          this.onToast('绑定成功')
          this.onInit()
          this.showPopup('code', false)
          this.logger.sum('挥剑问情_周年服新服预约活动_助力成功')
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 领取抽奖次数
    receiveNum () {
      // 判断有无抽奖次数
      for (let a = 0; a < this.my_inviter.length; a++) {
        if (this.my_inviter[a].is_get === 0) {
          this.receive()
          return
        }
      }
      for (let a = 0; a < this.person_invited.length; a++) {
        if (this.person_invited[a].is_get === 0) {
          this.receive()
          return
        }
      }
      for (let a = 0; a < this.new_player.length; a++) {
        if (this.new_player[a].is_get === 0) {
          this.receive()
          return
        }
      }
      for (let a = 0; a < this.level_reach.length; a++) {
        if (this.level_reach[a].is_get === 0) {
          this.receive()
          return
        }
      }
      this.onToast('暂无可领取次数')
    },
    receive () {
      onGetAPI({

      }).then(response => {
        if (Number(response.code) === 200) {
          this.onToast('领取成功')
          this.onInit()
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 抽奖
    lottery () {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (this.is_invite_end) return this.onToast('活动已结束')
      if (!this.lottery_dice) return this.onToast('抽奖次数不足')
      if (this.timer4) clearTimeout(this.timer4)
      this.timer4 = setTimeout(() => { // 防抖
        this.isPrevent = true
        onLotteryAPI({

        }).then(response => {
          if (Number(response.code) === 200) {
            this.prize_id = response.data.prize_id
            switch (this.prize_id) {
              case 1:
                this.rewardName = '金龙*188'
                break
              case 2:
                this.rewardName = '金龙*288'
                break
              case 3:
                this.rewardName = '金龙*588'
                break
              case 4:
                this.rewardName = '金龙*888'
                break
              case 5:
                this.rewardName = '金龙*1888'
                break
              case 6:
                this.rewardName = '金龙*3888'
                break
              case 7:
                this.rewardName = '金龙*8888'
                break
              case 8:
                this.rewardName = 'Switch'
                break
              case 9:
                this.rewardName = '茅台'
                break
            }
            this.showPopup('notice', true)
            setTimeout(() => {
              this.isPrevent = false // 等待弹窗显示
            }, 600)
            this.onInit()
            return
          }
          this.onToast(response.message)
        }).catch(() => {
          this.onToast('服务器出错啦')
        })
      }, 300)
    },
    toInvite (nickname) {
      if (!nickname) this.showPopup('share', true)
    },
    // 领取抽奖奖励
    async receiveLottery (is_good, id) {
      if (!this.is_buy && !this.is_reward_start) return this.onToast('活动已结束')
      this.reward_id = id
      if (is_good) {
        // 实物奖励
        this.showPopup('goods', true)
      } else {
        // 非实物奖励
        if (!this.role_id) {
          await this.searchAll()
          this.serverInfo = this.allServerInfo
          this.rewardBind = 3
          this.showPopup('server', true)
          return
        }
        this.onBookReward(1)
      }
    },
    // 领取抽奖奖励-换绑
    async changeBind () {
      await this.searchAll()
      this.serverInfo = this.allServerInfo
      this.rewardBind = 5
      this.showPopup('server', true)
    },
    /*
    * 功能:领取奖励
    * @param type {number} 1抽奖奖励,2购买奖励
    */
    onBookReward (type) {
      onBookRewardAPI({
        type,
        game_id: this.game_id,
        server_id: this.server_id,
        role_id: this.role_id,
        platform: 'android',
        role_name: this.role_name,
        os: 'android',
        id: this.reward_id
      }).then(response => {
        if (Number(response.code) === 200) {
          this.showPopup('server', false)
          this.onInit()
          this.showPopup('receiveSuccess', true)
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 领取实物奖励
    receiveGoods () {
      if (!this.is_reward_start) {
        this.onToast('活动已结束')
        return
      }
      if (!this.write_name) return this.onToast('姓名不能为空')
      if (!this.write_phone) return this.onToast('电话不能为空')
      if (!this.write_address) return this.onToast('地址不能为空')
      onAddressAPI({
        name: this.write_name,
        phone: this.write_phone,
        address: this.write_address,
        id: this.reward_id
      }).then(response => {
        if (Number(response.code) === 200) {
          this.onInit()
          this.showPopup('goods', false)
          this.onToast('领取成功,请注意查收')
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 周年预购
    async preOrder (id, is_get, _get, price, package_id) {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (this.is_buy) {
        // 预购时间：6月7号8点前
        if (_get) {
          // 已购买
          this.onToast('6月7日8:00开放领取至周年服')
        } else {
          // 未购买
          this.payment = true
          this.order_id = id
        }
      } else if (this.is_reward_start) {
        // 领取时间：7月1号0点前
        if (_get) {
          // 已购买
          if (is_get) {
            // 已领取
            this.onToast('礼包已领取，请注意查收')
          } else {
            // 未领取
            this.reward_id = id
            await this.searchNew()
            if (!this.newServerInfo.length) return this.onToast('未查询到周年服角色')
            this.serverInfo = this.newServerInfo
            this.rewardBind = 4
            this.showPopup('server', true)
          }
        } else {
          // 未购买
          this.onToast('礼包预购时间已截止')
        }
      } else {
        this.onToast('活动已结束')
      }
    },
    // 立即支付
    goToPay () {
      this.isPrevent = true
      let return_url = location.href.split('/prebook')[0] + '/prebook/query' + location.search
      onBuyAPI({
        pay_type: this.paymentData.pay_type,
        pay_method: this.paymentData.pay_method,
        order_id: this.order_id,
        return_url,
        open_id: this.open_id
      }).then(response => {
        if (Number(response.code) === 200) {
          // 支付订单存储
          this.order = response.data.order
          this.showPopup('paymentTips', true)
          if (navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
            if (this.paymentData.pay_type === 'wechat') {
              // 微信支付
              // 外部浏览器调用
              if (this.paymentData.pay_method === 'mp') {
                wx.chooseWXPay({
                  timestamp: response.data.data.timeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
                  nonceStr: response.data.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: response.data.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: response.data.data.signType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                  paySign: response.data.data.paySign, // 支付签名
                  success: function (res) {
                    // 支付成功后的回调函数
                    setTimeout(() => { this.isPrevent = false }, 1000)
                  },
                  fail: function (res) {
                    setTimeout(() => { this.isPrevent = false }, 1000)
                  }
                })
                setTimeout(() => { this.isPrevent = false }, 2000)
              } else if (response.data.data !== '') {
                window.location.href = response.data.data
                setTimeout(() => { this.isPrevent = false }, 1000)
              }
            } else if (response.data.data !== '') {
              // 支付宝支付
              document.getElementById('aliPayBtn').innerHTML = response.data.data
              document.forms['alipaysubmit'].submit()
              setTimeout(() => { this.isPrevent = false }, 1000)
            }
          }
          this.logger.sum('挥剑问情_周年服新服预约活动__点击确定付款按钮')
          return
        }
        this.onToast(response.message)
        setTimeout(() => { this.isPrevent = false }, 500)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    orderQuery (boolean) {
      this.showPopup('paymentTips', false)
      // 订单轮询
      boolean ? this.wait = 15 : this.wait = 2
      this.orderLoop(boolean)
    },
    // 订单轮询
    orderLoop (boolean) {
      if (this.wait > 0) {
        this.wxPayment(boolean)
        this.wait--
        this.isPrevent = true
        Indicator.open()
        setTimeout(() => {
          this.orderLoop(boolean)
        }, 1500)
      } else {
        this.isPrevent = false
        this.onToast('很抱歉,支付失败!')
      }
    },
    // 订单查询
    wxPayment (boolean) {
      onBuyShowAPI({
        trade_no: this.order
      }).then(response => {
        if (Number(response.code) === 200) {
          // 支付成功
          this.wait = 0
          if (boolean) this.onToast(response.message)
          this.showPopup('payment', false) // 关闭支付弹窗
          this.isPrevent = false
          this.showPopup('paymentSuccess', true)
          this.onInit() // 初始化数据
          Indicator.close()
          return
        }
        if (Number(response.code) !== 200) {
          if (this.wait === 0) {
            // if (boolean) this.onToast(response.message)
            Indicator.close()
          }
        }
      })
    },
    // 复制链接
    copyLink (copyName) {
      if (!this.user_account) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return
      }
      if (this.is_collect_end && this.is_invite_end) return this.onToast('活动已结束')
      var _this = this
      const clipboard = new Clipboard(copyName)
      clipboard.on('success', (e) => {
        _this.onToast('复制成功')
        e.clearSelection()
      })
      clipboard.on('error', (e) => {
        _this.onToast('复制失败')
      })
      this.logger.sum('挥剑问情_周年服新服预约活动_复制成功')
    },
    // 区组弹窗注销
    osCancel () {
      this.user_account = null
      this.user_id = null
      window.localStorage.setItem('access_token', '')
      onLogoutAPI({
        game_id: 69
      }).then(response => {
        if (Number(response.code) === 200) {
          this.invite_num = 0
          this.isNew = false
          this.user_account = null
          this.user_id = null
          this.collect_dice = 0
          this.collect_reward = ['', '', '']
          this.collect_reward_number = 0
          this.collect_number = null
          this.choice_id = 0
          this.has_card = []
          this.card_id = null
          this.task_info = ['', '', '', '', '']
          this.invite_code = 'xxxxxxx'
          this.is_has_invite = false
          this.lottery_dice = 0
          this.lottery_list = []
          this.my_inviter = []
          this.person_invited = []
          this.new_player = []
          this.level_reach = []
          this.team_info = []
          this.is_open_start = false
          this.is_reward_start = false
          this.orderList = ['', '', '']
          this.pay_list = []
          this.serverInfo = []
          this.newServerInfo = []
          this.newServerInfo2 = []
          this.allServerInfo = []
          this.server_name = null
          this.server_id = null
          this.role_name = null
          this.role_id = null
          this.rewardBind = null
          this.rewardName = null
          this.reward_id = null
          this.people = null
          this.shareLink = ''
          this.write_code = ''
          this.write_name = ''
          this.write_phone = ''
          this.write_address = ''
          this.is_bind = null
          this.bind_role_name = null
          this.bind_server_name = null
          this.isPrebook = null
          this.showPopup('server', false)
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config
      }
      Toast(curConfig)
    },
    // 前往重定向
    goLink (url, loggerName) {
      if (url === '') return this.onToast('敬请期待！')
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url }, 200)
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/hjwq/prebook/enter${getTimeStamp()}`,
        title: '新仙剑 | 一周年庆典活动',
        imgUrl: 'https://download4.qcplay.com/xianjian/yuyue/ico.png',
        desc: '海量金龙、茅台、自选侠客等福利应有尽有，速来预约周年服，入坑回坑就趁现在！'
      })
    },
    ...mapMutations([
      'setInitUserInfo',
      'setInitActiveInfo',
      'changeLoginPopup'
    ]),
    ...mapActions(['setShare'])
  }
}
</script>

<style lang="less">
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/prebook/index/index.vue